import { QueryFunctionContext } from 'react-query'
import request from 'services/axios'

export const settingImageChange = async (payload: ISettingImagePayload) => {
    const { data } = await request.post(
        `/moneypool_management/moneypool/${payload.id}/update/`,

        {
            name: payload.name,
            bank_balance: payload.bankBalance,
            interval: payload.interval,
            share_value: payload.shareValue,
            day_of_duetion: payload.dayOfDuetion,
            type: payload.type,
            notification_announce: payload.notificationAnnounce,
            sms_announce: payload.smsAnnounce,
            custom_avatar: 'None',
            image_id: payload.imageId,
        }
    )
    return data
}

export const settingManageChange = async (payload: ISettingManagePayload) => {
    const { data } = await request.post(
        `/moneypool_management/moneypool/${payload.id}/update/`,

        {
            name: payload.name,
            bank_balance: payload.bankBalance,
            interval: payload.interval,
            share_value: payload.shareValue,
            day_of_duetion: payload.dayOfDuetion,
            type: payload.type,
            notification_announce: payload.notificationAnnounce,
            sms_announce: payload.smsAnnounce,
            custom_avatar: 'None',
            image_id: payload.imageId,
            bank_account: payload.bankAccount,
            trust_state: payload.trustState,
        }
    )
    return data
}

export const settingChangeShareUser = async (
    payload: IChangeShareSettingPayload
) => {
    const { data } = await request.post(
        `/moneypool_management/${payload.moneyPool}/poolship/update/${payload.poolShip}/`,

        {
            number_of_shares: payload.share,
            role: payload.role,
        }
    )
    return data
}

export const settingChangeToManager = async (
    payload: IChangeManagerSettingPayload
) => {
    const { data } = await request.post(
        `/moneypool_management/${payload.moneyPool}/poolship/update/${payload.poolShip}/`,

        {
            role: payload.role,
            number_of_shares: payload.share,
        }
    )
    return data
}

export const settingSetGuarantor = async (
    payload: ISetGuarantorSettingPayload
) => {
    const { data } = await request.post(
        `/moneypool_management/${payload.moneyPool}/poolship/update/${payload.poolShip}/`,

        {
            number_of_shares: payload.share,
            role: payload.role,
            ...(payload.guarantor && { guarantor: payload.guarantor }),
            ...(payload.recommender && { recommender: payload.recommender }),
        }
    )
    return data
}

export const deactivateSetting = async (payload: {
    id: string | undefined
    poolShip: number | undefined
}) => {
    const { data } = await request.post(
        `/moneypool_management/${payload.id}/poolship/deactivate/${payload.poolShip}/`
    )
    return data
}

export const activateSetting = async (payload: {
    id: string | undefined
    poolShip: number | undefined
}) => {
    const { data } = await request.post(
        `/moneypool_management/${payload.id}/poolship/activate/${payload.poolShip}/`
    )
    return data
}
export const getBoxSettingTransparency = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IBoxSettingTransparency } = await request.get(
        `/api/v1/settings/box-settings/moneypool/${ctx.queryKey[1]}/`
    )
    return data
}

export const settingTransparency = async (
    payload: ISettingTransparencyPayload
) => {
    const { data } = await request.post(
        `/api/v1/settings/box-settings/moneypool/${payload.moneyPool}/`,

        {
            show_others_loans: payload.show_others_loans,
            show_others_loan_demands: payload.show_others_loan_demands,
            show_others_transactions: payload.show_others_transactions,
            show_other_members: payload.show_other_members,
            show_others_to_be_paid_portion:
                payload.show_others_to_be_paid_portion,
            show_box_balance: payload.show_box_balance,
            show_others_installments: payload.show_others_installments,
        }
    )
    return data
}

export const settingSMS = async (payload: ISettingSMSPayload) => {
    const { data } = await request.post(
        `/api/v1/settings/box-settings/moneypool/${payload.moneyPool}/`,

        {
            sms_others_define_loan: payload.sms_others_define_loan,
            sms_pay_portion_reminder: payload.sms_pay_portion_reminder,
            sms_pay_installment_reminder: payload.sms_pay_installment_reminder,
            sms_inform_managers_of_cashins:
                payload.sms_inform_managers_of_cashins,
            sms_opening_time: '00:00',
            sms_closing_time: '23:59:00',
            message_others_loan: payload.message_others_loan,
            notif_others_loan: payload.notif_others_loan,
            loan_digest_interval: payload.loan_digest_interval,
        }
    )
    return data
}
